import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ChipView extends React.PureComponent {
    render() {
        const chipView = (
            <div className={styles.content_list}>
                {/* <Chip id="260756" type="struct" title="引导胶片图片" groupName="引导胶片图片">
                    <div className={styles.chip_item} />
                </Chip> */}
                <Chip id="260796" type="struct" title="页面图片素材" groupName="页面图片素材">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260761" type="struct" title="首页嘉宾列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288090" type="recommend" title="二级页嘉宾1视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260762" type="struct" title="二级页嘉宾1名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288091" type="recommend" title="二级页嘉宾2视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260763" type="struct" title="二级页嘉宾2名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288092" type="recommend" title="二级页嘉宾3视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260764" type="struct" title="二级页嘉宾3名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288093" type="recommend" title="二级页嘉宾4视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260765" type="struct" title="二级页嘉宾4名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288094" type="recommend" title="二级页嘉宾5视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260766" type="struct" title="二级页嘉宾5名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288095" type="recommend" title="二级页嘉宾6视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260767" type="struct" title="二级页嘉宾6名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288096" type="recommend" title="二级页嘉宾7视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260768" type="struct" title="二级页嘉宾7名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288097" type="recommend" title="二级页嘉宾8视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260769" type="struct" title="二级页嘉宾8名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288098" type="recommend" title="二级页嘉宾9视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260770" type="struct" title="二级页嘉宾9名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288099" type="recommend" title="二级页嘉宾10视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260771" type="struct" title="二级页嘉宾10名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288100" type="recommend" title="二级页嘉宾11视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260772" type="struct" title="二级页嘉宾11名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="288101" type="recommend" title="二级页嘉宾12视频列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="260773" type="struct" title="二级页嘉宾12名言和卷轴图片列表" groupName="嘉宾信息列表">
                    <div className={styles.chip_item} />
                </Chip>
            </div>
        );

        return ReactDOM.createPortal(chipView, document.body);
    }
}

export default errorBoundary(ChipView);
